import { addDaysYmd } from "./promotions";

/**
 * Runs of open nights long enough for the minimum stay, in date order. Shared
 * by the "next open dates" chips and the last-minute offer, so both offer the
 * same dates.
 */
export type OpenWindow = { start: string; end: string; nights: number };

export function openWindowsFrom(
  availableDates: string[],
  minNightsFor: (checkIn: string) => number,
  limit = 3,
): OpenWindow[] {
  const days = [...new Set(availableDates)].sort();
  const runs: OpenWindow[] = [];
  let start: string | null = null;
  let prev: string | null = null;
  const close = () => {
    if (!start || !prev) return;
    const end = addDaysYmd(prev, 1);
    const nights = Math.round((Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86_400_000);
    if (nights >= minNightsFor(start)) runs.push({ start, end, nights });
    start = null;
    prev = null;
  };
  for (const d of days) {
    if (!start) { start = d; prev = d; continue; }
    if (addDaysYmd(prev!, 1) === d) { prev = d; continue; }
    close();
    start = d;
    prev = d;
  }
  close();
  return runs.slice(0, limit);
}

